<template lang="pug">
  pagina
    breadcrumb(slot="breadcrumb" :itens="this.breadcrumb")
    noticias(slot="principal", :pagination="true", :perPage="10")
    sidebar(slot="lateral")
</template>

<script>
  import Breadcrumb from 'MODULES/Breadcrumb'
  import Noticias from 'MODULES/Noticias'
  import Pagina from 'MODULES/Pagina'
  import Sidebar from 'MODULES/Sidebar'

  import * as config from '../../js/config'

  export default {
    components: {
      Breadcrumb,
      Noticias,
      Pagina,
      Sidebar
    },
    data () {
      return {
        breadcrumb: [
          { nome: 'Notícias' }
        ]
      }
    },
    head: {
      title: function () {
        return {
          inner: config.SITE_TITLE + ' - Notícias'
        }
      },
      meta: [
        {
          name: 'description', content: config.SITE_DESC + ' - área de notícias do site', id: 'description'
        }
      ]
    }
  }
</script>



// WEBPACK FOOTER //
// Noticias.vue?ac0fd37c